import React from "react";
import { ReactComponent as Loader } from "../../assets/Spinner.svg";
import { ReactComponent as LoaderSecondary } from "../../assets/SpinnerBlack.svg";
import "./Button.css";

interface Props {
  children?: React.ReactNode;
  type?: any;
  onClick?: () => void;
  style?: React.CSSProperties;
  loading?: boolean;
  disabled?: boolean;
  image?: React.ReactNode;
  spinnerSecondary?: boolean;
  className?: string;
}

const Button: React.FC<Props> = ({
  type = "submit",
  spinnerSecondary = false,
  children,
  style,
  onClick,
  loading = false,
  disabled = false,
  image,
  className,
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`button-pattern ${className}`}
      style={style}
      onClick={onClick}
    >
      {loading ? (
        spinnerSecondary ? (
          <LoaderSecondary className="spinner" />
        ) : (
          <Loader className="spinner" />
        )
      ) : (
        <>
          {children}
          {image}
        </>
      )}
    </button>
  );
};

export default Button;
